// extracted by mini-css-extract-plugin
export var content = "_q9-1";
export var fullScreen = "_q9-0";